<!-- Screenname:Store Master Table View
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <!-- <Header></Header> -->
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout
            :headertext="$t('stores.StoreMaster.List')"
            :contenttext="$t('stores.StoreMaster.TableHeaderContent')"
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col sm="12">
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Store Master"
                econtent="Store Master"
                eimg="/src/assets/Img/icons/StoreMaster.svg"
                @createNew="IsAdd"
              />
              <Tableview
                v-if="List.length !== 0"
                :value="List"
                :paginator="true"
                class="p-datatable-gridlines"
                :rows="10"
                :rowHover="true"
                filterDisplay="menu"
                :loading="loading1"
                responsiveLayout="scroll"
                :columns="headers"
                dataKey="Id"
                :globalFilterFields="globalFilterFields"
                :filters="filters"
                selectionMode="single"
                @row-click="RowClick"
                :exceldownload="true"
              >
                <template v-slot:Add>
                  <span class="add">
                    <AddButton
                      @click="IsAdd()"
                      :btnname="$t('btn.plusaddnew')"
                      class="float-rights my-3"
                    >
                    </AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption
                    @ExportExcel="ExportExcel"
                    @ExportPDF="ExportPDF"
                    :ExportList="ExportList"
                    PageName="Store Master"
                    :ExportOption="ExportOption"
                    class="ms-2"
                    :HideAndShow="true"
                  />
                </template>
                <template v-slot:Code="{ data }">
                  <span>
                    <b>{{ data.Code }}</b>
                    <div v-if="data.StoreTypeId == 3 && data.IsCamp == true">
                      <span class="CampName">(Camp)</span>
                    </div>
                  </span>
                </template>
                <template v-slot:status="{ data }">
                  <!-- <Badge v-if="data.IsActive == '1'" severity="success">{{
                    "Active"
                  }}</Badge>
                  <Badge v-if="data.IsActive == '0'" severity="warning">{{
                    "InActive"
                  }}</Badge> -->
                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                </template>
                <template v-slot:Category="{ data }">
                  <p
                    @click="
                      navigatetopage(
                        'CategoryTableview',
                        data.CategoryCount,
                        data
                      )
                    "
                  >
                    {{ data.CategoryCount }}
                  </p>
                </template>
                <template v-slot:parentCount="{ data }">
                  <p
                    @click="
                      navigatetopage('Createstore', data.parentCount, data)
                    "
                  >
                    {{ data.parentCount }}
                  </p>
                </template>
                <!-- childCount -->
                <template v-slot:childCount="{ data }">
                  <p
                    @click="
                      navigatetopage('Createstore', data.childCount, data)
                    "
                  >
                    {{ data.childCount }}
                  </p>
                </template>
                <!-- parentCount -->
                <template v-slot:ProductCount="{ data }">
                  <p
                    @click="
                      navigatetopage(
                        'ItemMasterTableview',
                        data.ProductCount,
                        data
                      )
                    "
                  >
                    {{ data.ProductCount }}
                  </p>
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <!-- <EditIcon @click="IsConfirmEdit(data)" class="me-3" />

                                    <DeleteIcon @click="IsConfirmDel(data)" /> -->
                    <Button
                      icon="pi pi-ellipsis-v"
                      class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)"
                    />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="List.length === 0 && !loading"
                eheader="Store Master"
                econtent="Store Master"
                eimg="/src/assets/Img/icons/StoreMaster.svg"
                @createNew="IsAdd"
              />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div
                      class="d-flex align-items-center justify-content-between gap-2"
                    >
                      <div>
                        <p class="light-name">{{ item.Code }}</p>
                        <div class="d-flex align-items-center gap-1">
                          <p class="name">{{ item.Name }}</p>
                          <p class="small-name">
                            ({{
                              item.StoreTypeId === 1
                                ? "MS"
                                : item.StoreTypeId === 2
                                ? "SS"
                                : item.StoreTypeId === 3
                                ? "DS"
                                : ""
                            }})
                          </p>
                        </div>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <!-- <Badge v-if="item.IsActive == '1'" severity="success">{{
            "Active"
          }}</Badge>
                          <Badge v-if="item.IsActive == '0'" severity="warning">{{
            "InActive"
          }}</Badge> -->
                          <OrangeStatus
                            name="InActive"
                            v-if="item.IsActive == '0'"
                          />
                          <GreenStatus
                            name="Active"
                            v-if="item.IsActive == '1'"
                          />
                        </div>
                        <i
                          class="pi pi-ellipsis-v"
                          @click="toggle($event, item)"
                        ></i>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center gap-2"
                      v-if="item.BranchId"
                    >
                      <p class="light-name">Branch :</p>
                      <p class="small-name">{{ item.BranchId }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Transaction Billing :</p>
                      <p class="small-name">
                        {{ item.TransactionBillingvalue }}
                      </p>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                      v-if="item.CategoryCount !== 0"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Caregory :</p>
                        <p class="small-name">{{ item.CategoryCount }}</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <p class="light-name">Product :</p>
                        <p class="small-name">{{ item.ProductCount }}</p>
                      </div>
                    </div>
                    <b-row>
                      <b-col cols="6">
                        <p class="light-name">Parent Store</p>
                        <p class="small-name">{{ item.parentCount }}</p>
                      </b-col>
                      <b-col cols="6">
                        <p class="light-name">Child Store</p>
                        <p class="small-name">{{ item.childCount }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </MobileViewCardHeader>
              <!-- <div class="d-flex justify-content-center">
                <b-pagination v-model="currentPage" :total-rows="mobilerows" :per-page="perPage" size="md"
                  aria-controls="my-table"></b-pagination>
              </div> -->
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Menu
    ref="menu"
    id="overlay_menu"
    :model="itemListed"
    @click=""
    :popup="true"
  />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit(dataEdit)"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <DeleteConfirmationVue
    :DeleteModel="Deletemodel"
    :content="contentdel"
    @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false"
  />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <Mapping
    :visible="MappingPop.visible"
    @ok="closetrigger()"
    :content="MappingPop.content"
  />
  <Toast />
</template>

<script lang="ts">
import { RouterLink, RouterView, useRouter } from "vue-router";
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import Empty from "../../../../../../components/Masters/MasterEmpty.vue";

import commonservice from "../../../../Service/StoreService";

// import Tableview from '../../../../../../components/FormComponents/Table.vue';
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
export default defineComponent({
  components: {
    // Header,

    Tableview,
    BacktoPage,
    Headerlayout,
    Empty,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    Mapping,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);

    const filter = "";
    const showmodalref = ref(false);
    const storeId = ref(0);
    const storeType = ref(0);

    let loading1 = ref(false);

    const showDialog = ref(false);
    const selectedItem = ref();

    const rowFocus = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const dataEdit = ref({});
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();
    const MappingPop = ref({
      visible: false,
      content: "",
    });

    const toast = useToast();
    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        let result = await commonservice.getStoreListByUserId(
          usersData.UserId,
          usersData.OrganizationId,
          usersData.Admin,
          usersData.BranchId
        );

        let count = 0;
        result["result"] = result["result"]
          .filter(
            (items) => items.HospitalId == usersData.OrganizationId //&& items.BranchId == BranchId
          )
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        ExportList.value = result["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });
          filteredItem["Code"] = item.Code;
          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    // const edit = (data) => {
    //     selectedItem.value = data
    //     showDialog.value = true
    // }
    // const AddNew = () => {
    //     showDialog.value = true
    //     selectedItem.value = null
    // }
    // const handleClick = () => {
    //     selectedItem.value = null;
    //     showDialog.value = false;
    // }
    // const onHide = () => {
    //     debugger;
    //     selectedItem.value = null;
    //     showDialog.value = false;

    // }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(datas.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(datas.value, 2);
            },
          },
        ],
      },
    ]);

    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/Createstore",
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function RowClick(event: any) {
      debugger;
      // Editmodel.value = true
      rowFocus.value = true;
      dataEdit.value = event.data;

      router.push({
        path: "/StoreMasterDetails",
        query: {
          Id: event.data.Id,
          Type: "StoreId",
          storeType: event.data.StoreTypeId,
          storebranchmapid: event.data.StoreBranchMapId,
        },
      });
    }

    function navigatetopage(pagename, datacount, datas) {
      if (datacount != 0) {
        router.push({
          name: pagename,
          path: "/" + pagename,
          query: {
            storeId: datas.Id,
            storeType: datas.StoreTypeId,
          },
        });
      } else {
        alert("Somthing went wrong");
      }
    }
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Escape" && MappingPop.value.visible == true) {
        MappingPop.value.visible = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t("confirmation.activecontent");
        } else if (Status == 2) {
          contentdel.value = t("confirmation.inactivecontent");
        } else {
          contentdel.value = t("confirmation.deletecontent");
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }
    let List: any = ref([]);
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      StoreName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      BranchName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StoreTypeName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      TransactionBillingvalue: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      CategoryCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      parentCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      childCount: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ProductCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },

      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };
    const headers = [
      {
        header: t("stores.StoreMaster.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("stores.StoreMaster.branch"),
        field: "BranchName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("stores.StoreMaster.code"),
        field: "Code",
        slot: "Code",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("stores.StoreMaster.name"),
        field: "StoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("stores.StoreMaster.type"),
        field: "StoreTypeName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t("stores.StoreMaster.parent"),
        field: "parentCount",
        fieldDisplay: "false",
        slot: "parentCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      {
        header: t("stores.StoreMaster.child"),
        field: "childCount",
        slot: "childCount",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      {
        header: t("stores.StoreMaster.cat"),
        field: "CategoryCount",
        fieldDisplay: "false",
        slot: "Category",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Transaction Billing",
      //   field: "TransactionBillingvalue",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      // },

      {
        header: t("stores.StoreMaster.products"),
        field: "ProductCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        class: "smallwidth",
        bodyclass: "bluecolor right_td",
        slot: "ProductCount",
      },
      // {
      //   header: t("stores.StoreMaster.total"),
      //   field: "totalValue",
      //   render(row: any) {
      //     row.totalValue = "01";
      //     return row.totalValue;
      //   },
      //   bodyclass: "boldclass",
      // },
      {
        header: t("stores.StoreMaster.status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        slot: "status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];
    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    //Load Store Table
    async function IsShow() {
      try {
        debugger;
        loading.value = true;

        let result = await commonservice.getStoreListByUserId(
          usersData.UserId,
          usersData.OrganizationId,
          usersData.Admin,
          usersData.BranchId
        );

        let count = 0;
        List.value = result["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
          return item;
        });

        console.log(result["result"]);

        loading.value = false;
        debugger;
      } catch {
        loading.value = false;
      }
    }

    //Store Edit
    function IsEdit(data) {
      debugger;
      router.push({
        name: "Createstore",
        query: {
          storeId: data.Id,
          storeType: data.StoreTypeId,
          StoreBranchId: data.BranchId,
        },
      });
    }
    async function IsDelete(data) {
      loading.value = true;
      try {
        debugger;
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await commonservice.deleteStore(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await commonservice.active(data.Id, status);
        }
        console.log(result);
        let message = result["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (result["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = result["result"];
          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch {
        loading.value = false;
      }
    }

    return {
      navigatetopage,
      filter,
      showmodalref,
      IsAdd,
      showpopModal: showmodalref,
      List,
      headers,
      loading1,
      filters,
      globalFilterFields,
      IsShow,
      IsEdit,
      IsDelete,
      RowClick,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      dataEdit,
      Editmodel,
      editItems,
      MappingPop,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>

<style lang="scss" scoped>
.mobilestorename {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobliestorecode {
  font-size: 16px;
  font-weight: 500;
  margin-top: -7px;
}

.mobilestorelightname {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 400;
}

.CampName {
  font-size: 14px;
  color: #2a9f0a;
}
</style>
